export default {
  tab: '座位列表',
  title: '座位列表',
  description: '查看所有座位的分配情况，可按座位场地、分配状态筛选与搜索；如需调整具体座位，请点击上方可视化「进入座位编排」。',
  export: '导出座位表',
  enterEditor: '进入座位编排',
  totalSeats: '座位总数',
  seatUnit: '个',
  assigned: '已分配',
  emptyLabel: '空置座位',
  usageRate: '使用率',
  allMeetings: '全部会议场次',
  allLayouts: '全部座位场地',
  allStatuses: '全部分配状态',
  statusAssigned: '已分配',
  statusEmpty: '空置',
  statusLocked: '已锁定',
  search: '搜索座位号 / 姓名 / 单位 / 职务 / 场地',
  summary: '共 {total} 个座位 · 已分配 {assigned} · 空置 {empty}',
  index: '序号',
  member: '参会人员',
  seatNo: '座位号',
  seatNoSuffix: ' 号',
  unit: '区域 / 单元',
  layout: '座位场地',
  seatType: '席位类型',
  session: '所属场次',
  organization: '社团 / 单位',
  jobTitle: '职务',
  status: '分配状态',
  statuses: {
    assigned: '已分配',
    empty: '空置',
    locked: '已锁定'
  },
  adjust: '调整座位',
  release: '释放',
  releaseConfirm: '确定释放座位 {seat} 的人员 {name} 吗？',
  releaseSuccess: '座位已释放',
  emptyState: '暂无座位数据'
}
